// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey.dark,
        },
        arrow: {
          color: theme.palette.grey.dark,
        },
      },
    },
  };
}
